import { gql } from "@apollo/client";

const UPDATE_EMAIL_TEMPLATE = gql`
  mutation updateEmailTemplate($input: UpdateEmailTemplate!) {
    updateEmailTemplate(input: $input) {
      data
      status
      error
    }
  }
`;
export default UPDATE_EMAIL_TEMPLATE;
